import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  TableHead,
} from "@mui/material";
import React from "react";

const headers = [
  ["Oligo Count", "Oligo targeting position in the transcript"],
  ["Oligo ID", "Concatenation of the oligo count and the accession number/gene name (helps identify a single oligo sequence)"],
  ["Target Region Sequence 20mer", "The 20nt target site sequence"],
  ["Gene Region", "50mer gene region (targeting region + 10 nts upstream and downstream flanking)"],
  ["GC Content", "GC content"],
  ["Revcomp Guide", "Reverse complement of the guide (antisense) strand (used during synthesis)"],
  ["Linear Score", "Legacy score from the linear model"],
  ["SSRF Score (ML ZScore)", "Updated ML ZScore"],
  ["Region", "ORF, 3'UTR, 5'UTR, etc."],
  ["Hits 2 MicroRNA", "Number of detected microRNA seeds"],
  ["RefSeq Seed", "16nt complementary region"],
  ["Hits 2 Accessions", "Hits to NCBI transcript accessions"],
  ["Hits 2 gIDs", "Number of targeted gene IDs"],
  ["gIDs", "NCBI gene ID (unique per Hugo gene; multiple transcripts/mRNAs can share the same gene ID)"],
  ["Accessions", "Number of targeted NCBI accession numbers for the given gene (different variants of the target)"],
  ["Hits 2 Mouse", "List of mouse NCBI accession numbers for the same gene targeted by this siRNA (blank for mouse designs)"],
  ["Hits 2 MM", "List of Macaca mulatta (rhesus monkey) accessions targeted by this siRNA (blank for Macaca mulatta designs)"],
  ["Hits 2 MF", "List of Macaca fascicularis (crab-eating macaque) accessions targeted by this siRNA (blank for Macaca fascicularis designs)"],
  ["Hits 2 Human", "List of human NCBI accessions targeted by this siRNA (blank for human designs)"],
  ["Hits 2 Rat", "List of rat NCBI accessions targeted by this siRNA (blank for rat designs)"],
];

export function InterpretationInstructions() {
  return (
     <>
      <Typography variant="h5" fontWeight={700} textAlign={"center"}>
        Interpretation of Results Columns
      </Typography>
      <TableContainer component={Paper} elevation={1}>
        <Table size="small" sx={{ tableLayout: "fixed", borderCollapse: "collapse" }}>
          {/* Header Row */}
          <TableHead>
            <TableRow sx={{ backgroundColor: "action.selected" }}>
              <TableCell
                sx={{
                  fontWeight: 700,
                  borderRight: "1px solid",
                  borderColor: "divider",
                  textAlign: "center",
                  width: "30%",
                }}
              >
                Column Name
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 700,
                  textAlign: "center",
                }}
              >
                Description of Field
              </TableCell>
            </TableRow>
          </TableHead>

          {/* Body Rows */}
          <TableBody>
            {headers.map(([header, desc], i) => (
              <TableRow key={i} sx={{ borderBottom: "1px solid", borderColor: "divider" }}>
                <TableCell
                  sx={{
                    fontWeight: 600,
                    borderRight: "1px solid",
                    borderColor: "divider",
                    width: "30%",
                    textAlign: "left",
                    verticalAlign: "middle",
                    backgroundColor: i % 2 === 0 ? "background.paper" : "action.hover",
                  }}
                >
                  {header}
                </TableCell>
                <TableCell
                  sx={{
                    color: "text.secondary",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    backgroundColor: i % 2 === 0 ? "background.paper" : "action.hover",
                  }}
                >
                  {desc}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}